import { fileFormat } from "../../types/types";
import { Action } from "../types";

const initialState: fileFormat = {
    "fileFormat": "",
    "config": {}  
}

export function FileFormatReducer(
    state: fileFormat = initialState,
    action: Action<any>) {
    switch (action.type) {
        case "fileFormatAction":
            return {
                ...action.payload
            };
    }
    return state;
}